import React, { useState } from "react";
import {
  Button,
  message,
  // Collapse,
  // List,
  Modal,
  Pagination,
  Table,
  Tag,
  Tooltip,
  // Typography,
} from "antd";
import { Splitter } from "antd";
import {
  ExpandOutlined,
  CompressOutlined,
  CloseOutlined,
  FormOutlined,
} from "@ant-design/icons";
import CommonTopDetails from "../CommonTopDetails";
import useCommonListing from "../customHooks/useCommonListing";
import axiosInstance from "../../../api/Axios";
import { useParams } from "react-router-dom";
import { capitalizeWords } from "../../icons/ApplicationColor";

const BulkBundleAdd = ({
  open,
  onClose,
  userInfo,
  course_id,
  LoadAPI,
  callMain,
}) => {
  const [fullscreen, setFullscreen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys2, setSelectedRowKeys2] = useState([]);
  const { id } = useParams();
  const columns = [
    {
      title: "Bundle ID",
      dataIndex: "bundle_id",
      key: "bundle_id",
      width: 100,
    },
    {
      title: "Bundle Name",
      dataIndex: "name",
      key: "bundleName",

      ellipsis: !fullscreen,
      width: 175,
    },
    {
      title: capitalizeWords("Users"),
      dataIndex: "user_count",
      key: "user_count",
      width: 80,
      editable: true,
      align: "center",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    {
      title: capitalizeWords("Courses"),
      dataIndex: "course_count",
      key: "course_count",
      width: 80,
      editable: true,
      align: "center",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "12px",
            width: "100%",
          }}
        >
          {text && text !== 0 ? (
            <Tag
              color="blue"
              style={{
                fontSize: "1.15rem",
                width: "2.5rem",
                height: "2.5rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "50%",
                fontWeight: "600",
                padding: 0,
              }}
            >
              {text}
            </Tag>
          ) : null}
        </div>
      ),
    },
    ...(fullscreen
      ? [
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
            ellipsis: true,
            width: 200,
          },
        ]
      : []),
  ];
  const passUrl = `/learn/bundlelist/?organization=${userInfo?.data?.organization?.id}&exclude_course_id=${id}`;

  const {
    data: data2,
    itemsLength: itemsLength2,
    loading: loading2,
    filterData: filterData2,
    onShowSizeChange: onShowSizeChange2,
    onPageChange: onPageChange2,
    handleSearchChange: handleSearchChange2,
    // setFilterData: setFilterData2,
    // handleSwitchChange: handleSwitchChange2,
    // handleClearAll: handleClearAll2,
    // setFilterUrl: setFilterUrl2,
  } = useCommonListing({
    userInfo,
    passSize: 10,
    passPage: 1,
    passURL: passUrl,

    loadAgain: open,
  });
  console.log(data2);
  const {
    pageSize: pageSize2,
    currentPage: currentPage2,
    // active: active2,
    // filter_url: filter_url2,
  } = filterData2;

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");

  const rowSelection2 = {
    selectedRowKeys: selectedRowKeys2,
    onChange: (newSelectedKeys, newSelectedRows) => {
      // Get all keys visible on current page
      const currentPageKeys = data2.map((row) => row.id || row.client_id);

      // Create a Set from current selections
      const updatedKeysSet = new Set(selectedRowKeys2);

      // Remove any deselected keys from current page
      currentPageKeys.forEach((key) => {
        updatedKeysSet.delete(key);
      });

      // Add all newly selected keys
      newSelectedKeys.forEach((key) => {
        updatedKeysSet.add(key);
      });

      // Final merged keys
      const finalKeys = Array.from(updatedKeysSet);
      setSelectedRowKeys2(finalKeys);
    },
  };

  const handleClose = () => {
    setFullscreen(false);
    setSelectedRowKeys2([]);

    onClose();
  };

  const submitData = async () => {
    setLoading(true);
    const payload = {
      course_ids: selectedRowKeys2,
      bundle_id: course_id,
    };
    console.log(payload);
    try {
      await axiosInstance.post(
        "learn/bundlecourseassign/",
        {
          bundle_ids: selectedRowKeys2,
          course_id,
        },
        {
          headers: {
            "X-CSRFToken": csrfToken,
          },
        }
      );
      message.success("Bulk assignment successful!");
      LoadAPI();
    } catch (error) {
      message.error("Bulk assignment failed. Please try again.");
    } finally {
      setLoading(false);
      callMain();
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span style={{ fontWeight: 600, fontSize: 18 }}>Bundle Assign</span>
        </div>
      }
      width={fullscreen ? "100vw" : 1300}
      style={fullscreen ? { top: 0, padding: 0, height: "100vh" } : {}}
      styles={{
        body: fullscreen
          ? { height: "calc(100vh - 100px)", overflow: "auto", padding: 0 }
          : { maxHeight: 800, overflow: "auto", padding: 0 },
      }}
      closeIcon={
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 16,
            marginRight: 40,
          }}
        >
          <Tooltip title={fullscreen ? "Exit Fullscreen" : "Expand"}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: fullscreen ? "#f0f0f0" : "transparent",
                boxShadow: fullscreen ? "0 0 4px #ccc" : "none",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                setFullscreen((prev) => !prev);
              }}
            >
              {fullscreen ? <CompressOutlined /> : <ExpandOutlined />}
            </span>
          </Tooltip>
          <Tooltip title="Close">
            <span
              style={{
                cursor: "pointer",
                fontSize: 20,
                color: "#555",
                borderRadius: "50%",
                padding: 4,
                transition: "background 0.2s, color 0.2s",
                background: "#f0f0f0",
                boxShadow: "0 0 4px #ccc",
                display: "flex",
                alignItems: "center",
              }}
              onClick={(e) => {
                e.stopPropagation();
                handleClose();
              }}
            >
              <CloseOutlined />
            </span>
          </Tooltip>
        </div>
      }
    >
      <div
        style={{
          width: "100%",
          // height: fullscreen ? "calc(100vh - 100px)" : 600,
          overflow: "hidden",
        }}
      >
        <Splitter style={{ width: "100%" }}>
          <Splitter.Panel
            defaultSize="100%"
            min="20%"
            max="80%"
            className="table-wrapper"
            style={{ overflowX: "auto", overflowY: "hidden" }}
          >
            <CommonTopDetails
              title={"Bundles"}
              titleSuffix={`${itemsLength2 || 0} bundle(s)`}
              searchPlaceholder="Search by ID or Title"
              searchAction={handleSearchChange2}
              marginPass="15px"
              paddingInlinepass="10px"
              showAddButton={false}
              filterAction={false}
              filterUrl={false}
            />
            <Table
              columns={columns}
              dataSource={data2}
              size="small"
              bordered
              rowKey="id"
              className="table-container"
              scroll={{
                x: 200,
                y: fullscreen ? 500 : 400,
              }}
              style={{ marginInline: "1rem" }}
              pagination={false}
              loading={loading2}
              rowSelection={rowSelection2}
            />
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                margin: "3rem",
                marginInline: "2rem",
                marginBottom: "1rem",
              }}
            >
              <Pagination
                size="small"
                showSizeChanger
                onShowSizeChange={onShowSizeChange2}
                onChange={onPageChange2}
                pageSizeOptions={["5", "10", "15", "30", "50", "100"]}
                current={currentPage2}
                defaultPageSize={pageSize2}
                total={itemsLength2}
              />
              <div
                style={{
                  display: "flex",
                }}
              >
                <Button
                  key="back"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                  }}
                  style={{ marginRight: "1rem" }}
                >
                  <CloseOutlined />
                  Cancel
                </Button>

                <Button
                  type="primary"
                  htmlType="submit"
                  onClick={submitData}
                  disabled={selectedRowKeys2.length === 0}
                  loading={loading}
                >
                  Save Assignment{selectedRowKeys2.length > 1 ? "s" : ""}
                  <FormOutlined />
                </Button>
              </div>
            </div>
          </Splitter.Panel>
        </Splitter>
      </div>
    </Modal>
  );
};

export default BulkBundleAdd;
